<template>

  <div class="px-2">
    <!-- Header -->
    <div class="d-flex justify-content-between">

      <div class="mb-3">
        <div class="d-flex" style="position: absolute; ">
          <div class="d-flex" v-if="psCharterShowDetail">
            <Button
              :size="20"
              color="#d42c2c"
              colorText="#ffffff"
              tooltip="Volver a resumen"
              text="Volver a resumen"
              :icon="'fas fa-angle-left'"
              :width="135"
              round
              :height="32"
              class="mr-2"
              :horizontal="true"
              @click.native="returnToGeneralView()"
              traslate
            />

            <Button
              :size="15"
              color="#28a745"
              colorText="#ffffff"
              tooltip="Agregar planificación semanal"
              icon="fas fa-plus"
              round
              :width="30"
              class="mr-2"
              traslate
              @click.native="actionSetCreateModePSCharter(true)"
            />
          </div>

          <filtro-planificacion-semanal />

        </div>
      </div>

    </div>

    <!-- Body -->
    <div class="mt-3">

      <div v-show="!psCharterShowDetail">
        <data-table-general-planificacion-semanal
          :weeks-totals="psCharterWeeksTotals"
          :data="dataResume"
          :current-weeks="psCharterCurrentWeeks"
          :idtabla="'ps_charter_general'"
          :paginacion="true"
          :max="15"
        />
      </div>

      <div v-show="psCharterShowDetail">
        <data-table-detalles-planificacion-semanal
          :data="dataDetail"
          :current-weeks="psCharterCurrentWeeks"
          :idtabla="'ps_charter_detail'"
          :paginacion="true"
          :max="15"
        />
      </div>

    </div>
  </div>

</template>

<script>

// Componentes
import DataTableGeneralPlanificacionSemanal from "../../dataTables/charter/DataTableGeneralPlanificacionSemanal.vue";
import DataTableDetallesPlanificacionSemanal from "../../dataTables/charter/DataTableDetallesPlanificacionSemanal.vue";
import { mapActions, mapState } from "vuex";
import Button from "@/components/common/Button.vue";
import FiltroPlanificacionSemanal from "@/components/filtros/charter/FiltroPlanificacionSemanal.vue";

export default {
  components: {
    FiltroPlanificacionSemanal,
    Button,
    DataTableGeneralPlanificacionSemanal,
    DataTableDetallesPlanificacionSemanal
  },
  data() {
    return {
      acciones: [],
      dataResume: [],
      dataDetail: [],
      totals: {
        week1: [0, 0],
        week2: [0, 0],
        week3: [0, 0],
        week4: [0, 0],
        week5: [0, 0]
      }
    };
  },
  computed: {
    ...mapState("charter", [
      "psCharterData",
      "psCharterDataDatatableGeneral",
      "psCharterDataDatatableGeneralFiltrada",
      "psCharterDataDatatableDetail",
      "psCharterDataDatatableDetailFiltrada",
      "psCharterCurrentWeeks",
      "psCharterShowDetail",
      "psCharterCurrentRegion",
      "psCharterCurrentWeek",
      "psCharterWeeksTotals",
      "psCharterEditingRowIndex"
    ])
  },
  methods: {
    ...mapActions(["AccionCambiar", "ActionSetZindexTablaModal", "ActionSetLoadingTable"]),
    ...mapActions("charter", [
      "actionSetDataPSCharter",
      "actionSetDataDatatableGeneralPSCharter",
      "actionSetDataDatatableDetailPSCharter",
      "actionSetCurrentWeeksPSCharter",
      "actionSetListaClientesPSCharter",
      "actionSetListaPalletsPSCharter",
      "actionSetListaEspeciesPSCharter",
      "actionSetShowDetailPSCharter",
      "actionSetCreateModePSCharter",
      "actionSetWeeksTotalsPSCharter",
      "actionSetFiltroPodsPSCharter",
      "actionSetFiltroClientesPSCharter",
      "actionSetFiltroEspeciesPSCharter",
      "actionSetFiltroRoutesPSCharter",
      "actionSetFiltroPalletsPSCharter",
      "actionSetShowDetailPSCharter",
      "actionSetEditingRowIndexPSCharter",
      "actionSetCreateModePSCharter"
    ]),
    async totalsCalculation() {

      const cleared_totals = {
        week1: [0, 0],
        week2: [0, 0],
        week3: [0, 0],
        week4: [0, 0],
        week5: [0, 0]
      };

      this.totals = cleared_totals;

      this.actionSetWeeksTotalsPSCharter(cleared_totals);

      await this.dataResume.forEach(element => {

        this.totals.week1[0] += parseInt(element.data[1]);
        this.totals.week1[1] += parseInt(element.data[2]);

        this.totals.week2[0] += parseInt(element.data[3]);
        this.totals.week2[1] += parseInt(element.data[4]);

        this.totals.week3[0] += parseInt(element.data[5]);
        this.totals.week3[1] += parseInt(element.data[6]);

        this.totals.week4[0] += parseInt(element.data[7]);
        this.totals.week4[1] += parseInt(element.data[8]);

        this.totals.week5[0] += parseInt(element.data[9]);
        this.totals.week5[1] += parseInt(element.data[10]);

      });

      this.actionSetWeeksTotalsPSCharter(this.totals);
    },
    async returnToGeneralView() {
      if (this.psCharterEditingRowIndex !== null) {
        this.$vToastify.prompt({
          body: "Hay cambios pendientes de guardar en uno de los planes semanales, ¿Desea cancelarlos?",
          answers: {
            "Sí": true,
            "No": false
          },
          type : "success",
        }).then(async value => {
          if (value) {
            await this.actionSetDataPSCharter();
            await this.actionSetCreateModePSCharter(false);
            await this.actionSetEditingRowIndexPSCharter(null);
            await this.actionSetShowDetailPSCharter(false);
          }
        });
      } else {
        await this.actionSetCreateModePSCharter(false);
        await this.actionSetShowDetailPSCharter(false);
      }
    }
  },
  watch: {
    psCharterData: async function(_new) {
      if (_new.code === 200) {
        this.actionSetDataDatatableGeneralPSCharter(_new.data);
        if (this.psCharterShowDetail) {
          const results = _new.data.find(x => x.data[0] === this.psCharterCurrentRegion[1]);
          this.actionSetDataDatatableDetailPSCharter(results !== undefined && results.data_complementaria.weeks[this.psCharterCurrentWeek].length >= 1 ? results.data_complementaria.weeks[this.psCharterCurrentWeek] : []);
        }

        //listas
        this.actionSetCurrentWeeksPSCharter(_new.current_weeks);
        this.actionSetListaClientesPSCharter(_new.customers_list);
        this.actionSetListaPalletsPSCharter(_new.pallets_list);
        this.actionSetListaEspeciesPSCharter(_new.species_list);

        //filtros
        this.actionSetFiltroPodsPSCharter(_new.ports_filter);
        this.actionSetFiltroClientesPSCharter(_new.customers_filter);
        this.actionSetFiltroPalletsPSCharter(_new.pallets_filter);
        this.actionSetFiltroEspeciesPSCharter(_new.species_filter);
        this.actionSetFiltroRoutesPSCharter(_new.routes_filter);

        await this.totalsCalculation();
      }
    },
    psCharterDataDatatableGeneral: async function(_new) {
      if (_new) {
        this.dataResume = _new;
        await this.totalsCalculation();
      }
    },
    psCharterDataDatatableGeneralFiltrada: async function(_new) {
      this.dataResume = _new;
      await this.totalsCalculation();
    },
    psCharterDataDatatableDetail: async function(_new) {
      if (_new) {
        this.dataDetail = _new;
      }
    },
    psCharterDataDatatableDetailFiltrada: async function(_new) {
      this.dataDetail = _new;
    }
  },
  mounted: async function() {
    await this.actionSetDataPSCharter();
  }
};
</script>